import React from 'react';
import DidYouKnow from '../show/DidYouKnow'
import EssentialsIntro from '../show/EssentialsIntro'
import Essentials from '../show/Essentials'
import CitiesBreakdown from './CitiesBreakdown'
import CountriesBreakdown from './CountriesBreakdown'
import Overview from '../show/Overview'
import Universe from '../show/Universe'
import ProfessionBreakdown from "./ProfessionBreakdown";
import Emotions from "./Emotions";
import DayOfWeek from "./DayOfWeek";
import WhenWhat from "./WhenWhat";
import WhenWhatIntro from '../show/WhenWhatIntro'
import TopPhrases from "./TopPhrases";
import EssentialLocation from "./EssentialLocation";
import GettingMoreSpecific from "./GettingMoreSpecific";
import Keywords from "./Keywords";
import SERP from "./SERP";
import InformationIntro from "./InformationIntro";
import Information1 from "./Information1";
import Information2 from "./Information2";
import ContentPillarStrategy1 from "./ContentPillarStrategy1";
import ContentPillarStrategy2 from "./ContentPillarStrategy2";
import ContentCreators from './ContentCreators';

const Content = ({ persona, can_unlock }) => (
  <React.Fragment>
    <Universe
      canUnlock={can_unlock}
      brandPhotos={persona.images.filter(image => image.category === 'brand')}
      essentialPhotos={persona.images.filter(image => image.genre === 'essentials')}
      interestsPhoto={persona.images.filter(image => image.genre === 'interests')}
      limitedView={!persona.payed}
      mediaTouchpointPhoto={persona.images.filter(image => image.genre === 'media_touchpoint')}
      personaId={persona.id}
      personaName={persona.name}
      personaPhotos={persona.images.filter(image => image.category === 'gender')}
    />

    <Overview
      category={persona.industry.label}
      limitedView={!persona.payed}
      photo={persona.images.filter(image => image.genre === 'overview')}
      locations={persona.locations.map(location => location.label)}
    />

    {persona.insights.some(insight => insight.dimention2 === 'countries') &&
      <CountriesBreakdown
        photo={persona.images.filter(image => image.genre === 'chart')}
        data={persona.insights.find(insight => insight.dimention2 === 'countries').results[0]['values']}
        limitedView={!persona.payed}
      />
    }

    <CitiesBreakdown
      photo={persona.images.filter(image => image.genre === 'chart')}
      data={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'cities').results[0]['values']}
      limitedView={!persona.payed}
    />

    <ProfessionBreakdown
      photo={persona.images.filter(image => image.genre === 'profession')}
      data={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'profession').results[0]['values']}
      limitedView={!persona.payed}
    />

    <Emotions
      photo={persona.images.filter(image => image.genre === 'emotions')}
      data={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'emotions').results[0]['values']}
      limitedView={!persona.payed}
    />

    <DayOfWeek
      photo={persona.images.filter(image => image.genre === 'day_of_the_week')}
      data={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'dayOfWeek').results[0]['values']}
      limitedView={!persona.payed}
    />

    <EssentialsIntro />

    <Essentials
      limitedView={!persona.payed}
      photo={persona.images.filter(image => image.genre === 'essentials')}
      name={persona.name}
      malePersonaName={persona.name.split('&')[0]}
      femalePersonaName={persona.name.split('&')[1]}
      topInterests={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'interest' && insight.dimention1 === 'queries').top5}
      topMaleInterests={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'interest' && insight.dimention1 === 'gender').metrics.top5_male}
      topFemaleInterests={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'interest' && insight.dimention1 === 'gender').metrics.top5_female}
      professions={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'profession' && insight.dimention1 === 'queries').top5}
    />

    {persona.locations.some(location => location.type === 'city') && <EssentialLocation
      limitedView={!persona.payed}
      photo={persona.images.filter(image => image.genre === 'essentials')}
      name={persona.name}
      malePersonaName={persona.name.split('&')[0]}
      femalePersonaName={persona.name.split('&')[1]}
      InterestVsGender={!persona.payed ? [{}] :persona.insights.filter(insight => insight.dimention1 === 'gender' && insight.dimention2 === 'interest' && insight.locations.length === 1)}
    />}

    <GettingMoreSpecific
      limitedView={!persona.payed}
      photo={persona.images.filter(image => image.genre === 'getting_more_specific')}
      professionInterests={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention1 === 'profession' && insight.dimention2 === 'interest').metrics}
    />

    <ContentCreators
      category={persona.industry.label}
      limitedView={!persona.payed}
      topTweeters={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention1 === 'toptweeters')}
    />

    <WhenWhatIntro
      photo={persona.images.filter(image => image.genre === 'content')}
    />

    <WhenWhat
      photo={persona.images.filter(image => image.genre === 'interests')}
      limitedView={!persona.payed}
      topDays={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'dayOfWeek' && insight.dimention1 === 'queries').top5}
      bottomDays={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'dayOfWeek' && insight.dimention1 === 'queries').bottom5}
      topHours={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'hourOfDay' && insight.dimention1 === 'queries').top5}
      bottomHours={!persona.payed ? [{}] :persona.insights.find(insight => insight.dimention2 === 'hourOfDay' && insight.dimention1 === 'queries').bottom5}
    />

    <TopPhrases
      photo={persona.images.filter(image => image.genre === 'top_phrases')}
      limitedView={!persona.payed}
      phrases={persona.top_phrases}
    />

    <Keywords
      photo={persona.images.filter(image => image.genre === 'keywords')}
      limitedView={!persona.payed}
      keywords={persona.keywords}
    />

    <SERP
      amazon={persona.amazon_serp}
      photo={persona.images.filter(image => image.category === 'industry')}
      industry={persona.industry}
      limitedView={!persona.payed}
      google={persona.google_serp}
      youtube={persona.youtube_serp}
    />

    <DidYouKnow
      brandPhotos=""
      limitedView={!persona.payed}
      creationDate={persona.created_at}
      trends={persona.trends}
    />

    <InformationIntro />

    <Information1
      limitedView={!persona.payed}
      regenerated={persona.regenerated}
    />

    <Information2
      industry={persona.industry}
      regenerated={persona.regenerated}
      limitedView={!persona.payed}
    />

    <ContentPillarStrategy1
      limitedView={!persona.payed}
    />

    <ContentPillarStrategy2
      limitedView={!persona.payed}
    />
  </React.Fragment>
);

export default Content
